import { useEffect, useState } from 'react'
import FBTabs from '../layout/Admin/FBTabs'
import PackageList from '../layout/Admin/PackageList'
import { allFBTabs } from '../../data/admin-data'
import CategoryList from '../layout/Admin/CategoryList'
import { useSelector } from 'react-redux'
import { selectCategoryName, selectCategoryTypeId } from '../../features/modal/modalSlice'
import ProductList from '../layout/Admin/ProductList'
import { useQueryData } from '../../hooks/api/useQueryData'
import FBOptionSorting from '../common/option-sorting/FBOptionSorting'
import Products from '../layout/Admin/Products'
import { useProductSocket } from '../../hooks/socket/useProductSocket'
import { useCategorySocket } from '../../hooks/socket/useCategorySocket'
import Setup from '../layout/Admin/Setup'

export default function FB() {

    const categoryName = useSelector(selectCategoryName);
    const categoryId = useSelector(selectCategoryTypeId);
    const { refetchProductBaseOnCategory } = useQueryData();
    const [activeTab, setActiveTab] = useState<number>(allFBTabs[0].id)
    const [selectedCategoryId, setSelectedCategory] = useState<number | null>(null)

    useEffect(() => {
        if (categoryId) {
            refetchProductBaseOnCategory();
        }
    }, [categoryId, refetchProductBaseOnCategory]);

    useProductSocket()

    return (
        <div className='bg-white rounded-md w-full h-full p-4 flex-1 flex flex-col space-y-3 overflow-hidden'>
            <FBOptionSorting activeTab={activeTab}/>
            <FBTabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                data={allFBTabs}
            />
            {activeTab === 1 && (
                // categoryId === selectedCategoryId ? (
                //     <ProductList
                //         categoryId={categoryId}
                //         setSelectedCategory={setSelectedCategory}
                //         categoryName={categoryName}
                //     />
                // ) : (
                //     <CategoryList 
                //         setSelectedCategory={setSelectedCategory} 
                //         typeOfAction={'viewListProduct'}
                //     />
                // )
                // <ProductList
                //     categoryId={categoryId}
                //     setSelectedCategory={setSelectedCategory}
                //     categoryName={categoryName}
                // />
                <Products/>
            )}
            
            {/* {activeTab === 2 && (
                <CategoryList 
                    typeOfAction={'viewListProductModal'}
                />
                
            )} */}

            {activeTab === 3 && (
                <PackageList 
                    typeOfUser={'admin'}
                />
            )}

            {activeTab === 4 && (
                <Setup/>
            )}
        </div>
    )
}
